export default __webpack_public_path__ + "static/media/sj-1-rMAX.586c1a0c.avif";